export default "__VITE_ASSET__b8ba96e5__"